export const oauthClientsQueryKeys = {
  all: () => ['oauth-clients'] as const,
  list: () => [...oauthClientsQueryKeys.all(), 'list'] as const,
  detail: (id: string) => [...oauthClientsQueryKeys.all(), 'detail', id] as const,
};
